import { ActionTree } from 'vuex';
import { ClipboardState } from './state';

export const actions: ActionTree<ClipboardState, any> = {
  setClipboard({ commit }, values: string[]) {
    commit('SET_CLIPBOARD', values);
  },
  clearClipboard({ commit }) {
    commit('CLEAR_CLIPBOARD');
  },
};
